import React from 'react';
import { ErrorModalTypes } from './error.constant';
import CandidateDuplicateModalComponent from '../components/Modal/PersonDublicate/CandidateDuplicateModal.component';
import NetworkErrorModalComponent from '../components/Modal/NetworkErrorModal.component';
import NoAccessModalComponent from '../components/Modal/NoAccessModal.component';

export const MODAL_CONTENT: { [key: string]: React.ComponentType } = {
  [ErrorModalTypes.CANDIDATE_DUPLICATE]: CandidateDuplicateModalComponent,
  [ErrorModalTypes.NETWORK_ERROR]: NetworkErrorModalComponent,
  [ErrorModalTypes.NO_ACCESS]: NoAccessModalComponent,
  [ErrorModalTypes.FORBIDDEN]: NoAccessModalComponent,
};
